import EmployeesHolidaysComponent from './EmployeesHolidaysComponent';

export default EmployeesHolidaysComponent;
